import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-hero">
        <h1 className="main-heading">Privacy Policy</h1>
        <p className="effective-date">Effective Date: July 25, 2025</p>
        <p className="intro-text">
          At SkillsHap, your privacy is a top priority. This Privacy Policy
          outlines how we collect, use, disclose, and safeguard your personal
          information when you use our platform, services, tools, or interact
          with us.
        </p>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">1. Information We Collect</h2>
        <div className="policy-content">
          <p>We may collect the following types of information:</p>
          <p><strong>a. Personal Information:</strong></p>
          <ul>
            <li>Full Name, Email, Phone Number, Address</li>
            <li>Educational & Employment Information</li>
            <li>LinkedIn or Resume Details (if submitted)</li>
            <li>Payment details (processed via third-party gateways)</li>
          </ul>
          <p><strong>b. Technical Information:</strong></p>
          <ul>
            <li>IP Address</li>
            <li>Browser Type & Device Info</li>
            <li>Usage data (pages visited, features used, etc.)</li>
          </ul>
          <p><strong>c. Optional User Inputs:</strong></p>
          <ul>
            <li>Feedback, support requests, form submissions, survey responses</li>
          </ul>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">2. How We Use Your Information</h2>
        <div className="policy-content">
          <ul>
            <li>Provide and improve our services</li>
            <li>Match candidates with job or training opportunities</li>
            <li>Offer personalized recommendations (using AI + human insights)</li>
            <li>Send important updates, alerts, and communication</li>
            <li>Analyze usage trends to improve our offerings</li>
            <li>For marketing and promotional purposes (with consent)</li>
          </ul>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">3. Legal Basis for Processing</h2>
        <div className="policy-content">
          <p>We process personal data under:</p>
          <ul>
            <li>Consent provided by users</li>
            <li>Performance of contract (e.g., job assistance)</li>
            <li>Legal obligations (e.g., tax/accounting)</li>
            <li>Legitimate interests (business analysis, fraud prevention)</li>
          </ul>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">4. How We Share Your Information</h2>
        <div className="policy-content">
          <p>We do not sell your personal data. However, we may share it with:</p>
          <ul>
            <li>Recruiters, Employers, or Coaches (only with your consent)</li>
            <li>Third-party service providers (CRM, hosting, payment processors)</li>
            <li>Legal/regulatory authorities when required</li>
            <li>Internal teams for support and training purposes</li>
          </ul>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">5. Cookies & Tracking Technologies</h2>
        <div className="policy-content">
          <p>We use cookies and similar tools to:</p>
          <ul>
            <li>Improve your experience</li>
            <li>Remember your preferences</li>
            <li>Track user behavior (for analytics & marketing)</li>
          </ul>
          <p>You can manage cookie preferences in your browser settings.</p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">6. Data Retention</h2>
        <div className="policy-content">
          <p>We retain personal data only as long as necessary:</p>
          <ul>
            <li>For service delivery or legal compliance</li>
            <li>Or until user requests deletion</li>
          </ul>
          <p>You may request deletion anytime by contacting us.</p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">7. Your Rights & Choices</h2>
        <div className="policy-content">
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access, correct, or delete your personal data</li>
            <li>Withdraw consent at any time</li>
            <li>Opt-out of marketing communications</li>
          </ul>
          <p>
            To exercise these rights, email us at:{" "}
            <a href="mailto:support@skillshap.com">support@skillshap.com</a>
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">8. Security of Your Data</h2>
        <div className="policy-content">
          <ul>
            <li>Encrypted data storage</li>
            <li>Secure payment integrations</li>
            <li>Limited access to sensitive information</li>
          </ul>
          <p>
            However, no method is 100% secure online. We urge users to also
            protect their accounts and use strong passwords.
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">9. Children’s Privacy</h2>
        <div className="policy-content">
          <p>
            SkillsHap is not intended for users under the age of 16. We do not
            knowingly collect personal data from children.
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">10. Third-Party Links</h2>
        <div className="policy-content">
          <p>
            Our platform may contain links to other websites. We are not
            responsible for the privacy practices or content of third-party
            sites.
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">11. Changes to This Privacy Policy</h2>
        <div className="policy-content">
          <p>
            We may update this policy from time to time. Any changes will be
            reflected on this page with an updated July 25, 2025.
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h2 className="policy-heading">12. Contact Us</h2>
        <div className="policy-content">
          <p>
            For questions or concerns about this Privacy Policy or your data:
            <br />
            📧{" "}
            <a href="mailto:support@skillshap.com">support@skillshap.com</a>
            <br />
            🌐{" "}
            <a href="https://www.skillshap.com" target="_blank" rel="noreferrer">
              www.skillshap.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;